module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-links_black-ddd29e0d972f9ce4e96de462d030fe72.svg";